//Please add the language resource
const shipper = {
  shipperCode: 'shipperCode',
  shipperName: 'shipperName',
  shipperShortName: 'shipperShortName',
  shipTypeName: 'shipTypeName',
  contactMan: 'contactMan',
  contactTel: 'contactTel',
  contactMail: 'contactMail',
  contactMobile: 'contactMobile',
  contactAddr: 'contactAddr',
  companyName: 'companyName',
  useCompanyName: 'useCompanyName',
  activeOffDesc: 'activeOffDesc',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
};
export default shipper



// WEBPACK FOOTER //
// ./src/page/mdm/shipper/lang/shipper.en.js